export default "__VITE_ASSET__DrpiDQ3w__"